var _style, _path, _path2, _path3, _path4, _g, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "waist_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 148 148",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".waist_svg__st0{fill:none;stroke:var(--color-text);stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "waist_svg__st0",
    d: "M118.7 71.9S105.1 85.2 74 85.2 29.3 71.9 29.3 71.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "waist_svg__st0",
    d: "M26.8 84C46 96.7 56.5 95.6 70.7 113c.8 1 2.1 1.5 3.3 1.5s2.5-.5 3.3-1.5c14.3-17.4 24.8-16.3 44-29M74 114.6v21.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "waist_svg__st0",
    d: "M37 53.9c-1.1 3-2.4 6.1-4 9.3-4.6 8.9-7.3 18.7-7.3 28.8-.1 12 2.5 27.7 12.3 44.2M35.4 11.9s8.7 13.5 3.6 35"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "waist_svg__st0",
    d: "M53.6 57.3C34.5 54.8 21 48.9 21 41.9c0-4.4 5.4-8.4 14.3-11.4M56.7 49.9l6.1 8.8-8.2 6.5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "waist_svg__st0",
    d: "M111 53.9c1.1 3 2.4 6.1 4 9.3 4.6 8.9 7.3 18.7 7.3 28.8.1 12-2.5 27.7-12.3 44.2M112.6 11.9s-8.7 13.5-3.6 35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "waist_svg__st0",
    d: "M94.4 57.3c19.2-2.5 32.7-8.5 32.7-15.4 0-4.4-5.4-8.4-14.3-11.4M91.3 49.9l-6.1 8.8 8.2 6.5"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1 90.5c-11.9 0-21.5-1.9-28.9-4.3 2.6 2.1 6.7 4.4 9 5.7.6.3 1.2.6 1.7.9h.1c6 3.3 11.8 7.5 18.2 15.1 6.4-7.5 12.2-11.7 18.2-15.1h.1c.6-.3 1.1-.6 1.7-.9 2.3-1.3 6.4-3.6 9-5.7-7.6 2.4-17.2 4.3-29.1 4.3z",
    fill: "var(--color-icon-secondary)"
  })));
}
export default SvgWaist;